import { useEffect, useState } from 'react'
import { X } from 'lucide-react'

import { useRoadbook } from '../../data/roadbookContext'
import type { PhotoMeta } from '../../lib/types'

/**
 * Ein Vorschaubild. Die Bilddaten kommen aus dem lokalen Speicher oder werden
 * einmalig vom Server geholt; die Objekt-URL wird beim Aufräumen freigegeben,
 * sonst sammelt sich das Tagebuch im Speicher an.
 */
export function PhotoThumb({ photo, stageTo }: { photo: PhotoMeta; stageTo: string }) {
  const { loadPhoto, deletePhoto, darfSchreiben } = useRoadbook()
  const [url, setUrl] = useState<string | null>(null)
  const [fehlt, setFehlt] = useState(false)

  useEffect(() => {
    let objectUrl: string | null = null
    let cancelled = false

    void (async () => {
      const blob = await loadPhoto(photo.id, photo.stageId)
      if (cancelled) return
      if (!blob) {
        setFehlt(true)
        return
      }
      objectUrl = URL.createObjectURL(blob)
      setUrl(objectUrl)
    })()

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [photo.id, photo.stageId, loadPhoto])

  return (
    <figure className="bild">
      {url ? (
        <img src={url} alt={`Foto von der Etappe nach ${stageTo}`} loading="lazy" />
      ) : (
        <span className="bild-fehlt">{fehlt ? 'offline nicht verfügbar' : 'lädt …'}</span>
      )}
      {darfSchreiben && (
        <button
          type="button"
          className="kein-druck"
          onClick={() => deletePhoto(photo.id)}
          aria-label="Foto entfernen"
        >
          <X size={12} />
        </button>
      )}
    </figure>
  )
}
